const r=r=>[...r].reduce(((r,e)=>26*r+e.charCodeAt(0)-64),0),e=r=>{if(r>=702)return"ZZ";let e="";for(;r;)r--,e=String.fromCharCode(65+r%26)+e,r=r/26|0;return e};export{r as lettersToNumber,e as numberToLetters};
